import {
  SkipLimitPageSpec,
  SortDirection,
  StringSearchFilterType,
} from '@warebee/shared/data-access-api-dto';
import _ from 'lodash';

import {
  ActualityHqQueryBuilderParams,
  ActualityHqSortBy,
  getActualityHqQueryBuilder,
} from '../actuality/cteQueryBuilders/actualityHqQueryBuilder';

export type ActualityHqQueryBuilderPagedClientParams = {
  sortBy?: ActualityHqSortBy[];
  page?: SkipLimitPageSpec;
};

export type ActualityHqQueryBuilderPagedParams = ActualityHqQueryBuilderParams &
  ActualityHqQueryBuilderPagedClientParams;

function getActualityHqDataRowsSelectPart(
  params: ActualityHqQueryBuilderParams,
) {
  return getActualityHqQueryBuilder(params)
    .selectFrom('hq')
    .selectAll()
    .where('eventId', 'is not', null);
}

function getActualityHqDataTotalSelectPart(
  params: ActualityHqQueryBuilderParams,
) {
  let builder = getActualityHqQueryBuilder(params)
    .selectFrom('hq')
    .select(({ fn }) => [fn.countAll<number>().as('totalCount')])
    .where('eventId', 'is not', null);
  return builder;
}

export function getActualityHqDataRowsQuery(
  params: ActualityHqQueryBuilderPagedParams,
) {
  let query = getActualityHqDataRowsSelectPart(params)
    .$if(!_.isNil(params.page), db => db.offset(params.page.skip ?? 0))
    .$if(!_.isNil(params.page), db => db.limit(params.page.limit ?? 100));

  _.forEach(params.sortBy, sb => {
    query = query.orderBy(
      sb.field,
      sb.direction === SortDirection.ASC ? 'asc' : 'desc',
    );
  });
  return query;
}

export function getActualityHqDataTotalQuery(
  params: ActualityHqQueryBuilderPagedParams,
) {
  let query = getActualityHqDataTotalSelectPart(params);

  if (params.filterBy) {
    query = _.reduce(
      params.filterBy,
      (q, value, key) => {
        if (
          value?.type === StringSearchFilterType.CONTAINS &&
          value?.value === 'undefined'
        ) {
          return q.where(key as any, 'is', null);
        }

        if (
          value?.type === StringSearchFilterType.CONTAINS &&
          !_.isEmpty(value?.value)
        ) {
          return q.where(key as any, 'like', `%${value.value}%`);
        }
        return q;
      },
      query,
    );
  }

  return query;
}
